import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import useAuthStore from '../store/authStore';

// Shared tab bar for the Expenses section - the sidebar now has a single
// "Expenses" entry (merged from 4 separate links per user request,
// 2026-08-19), so this is how you switch between Dashboard/Site/Factory/
// Vendor once you're inside the section. Same active-state pattern as
// Sidebar.js (exact pathname match) and the same pill styling as
// PaymentsPage's Sheet/Graph toggle.
const TABS = [
  { to: '/expenses', label: 'Dashboard' },
  { to: '/expenses/site', label: 'Site' },
  { to: '/expenses/factory', label: 'Factory' },
  { to: '/expenses/vendor', label: 'Vendor' },
  { to: '/expenses/purchases', label: 'Purchases' },
];

// The Summary tab is a separate, deliberately sparse view built for the
// Owner/CEO - see ExpenseCeoSummaryPage.js's docstring. Hidden for
// everyone else (UI convenience only, real enforcement is server-side -
// the endpoints it reads are open to any authenticated employee same as
// the rest of the dashboard, nothing sensitive is exposed either way).
const CEO_SUMMARY_ROLES = ['CEO', 'System_Admin'];

const ExpenseTabs = () => {
  const location = useLocation();
  const { user } = useAuthStore();
  const tabs = CEO_SUMMARY_ROLES.includes(user?.role)
    ? [...TABS, { to: '/expenses/summary', label: 'Summary' }]
    : TABS;
  return (
    <div className="glass-widget flex gap-1 p-1.5 mb-6 w-fit">
      {tabs.map((tab) => {
        const active = location.pathname === tab.to;
        return (
          <Link
            key={tab.to}
            to={tab.to}
            className={`text-sm px-4 py-1.5 rounded-xl font-medium transition-colors ${
              active ? 'bg-white/90 text-komal-blue' : 'text-white/85 hover:bg-white/10'
            }`}
          >
            {tab.label}
          </Link>
        );
      })}
    </div>
  );
};

export default ExpenseTabs;
